/**
 * フローティングバナー
 * 右下に表示されるフローティングバナーの制御
 */
class ATFloatingBanner {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.banner = element;
    this.closeButton = this.banner.querySelector('.at-floating-banner__close');
    this.storageKey = 'at-floating-banner-closed';
    this.sectionId = this.banner.dataset.sectionId;
    
    this.init();
  }

  init() {
    // ページが完全にロードされてから少し遅延させてスライドインアニメーションを開始
    const showBanner = () => {
      setTimeout(() => {
        this.banner.classList.add('is-visible');
      }, 800); // ロード画面が終わった後に表示されるよう遅延
    };

    // ページが既にロード済みの場合はすぐに実行
    if (document.readyState === 'complete') {
      showBanner();
    } else {
      // まだロード中の場合はloadイベントを待つ
      window.addEventListener('load', showBanner);
    }

    // 閉じるボタンのイベントリスナー
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    // Escapeキーでも閉じられるようにする
    document.addEventListener('keydown', this.handleKeyPress.bind(this));
  }

  /**
   * 閉じるボタンをクリックした時の処理
   * @param {Event} event
   */
  handleClose(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // is-visibleクラスを削除して閉じるアニメーションを開始
    this.banner.classList.remove('is-visible');
    this.banner.classList.add('is-closing');
    
    // アニメーション完了後に完全に非表示
    setTimeout(() => {
      this.banner.style.display = 'none';
      // 毎回表示するため、状態は保存しない
    }, 600); // CSSのtransition時間と合わせる
  }

  /**
   * Escapeキーで閉じる
   * @param {KeyboardEvent} event
   */
  handleKeyPress(event) {
    if (event.key === 'Escape' && this.banner && !this.banner.classList.contains('is-closing')) {
      this.handleClose(event);
    }
  }

  /**
   * クリーンアップ
   */
  destroy() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleClose);
    }
    document.removeEventListener('keydown', this.handleKeyPress);
  }
}

// DOM読み込み完了後に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFloatingBanner);
} else {
  initFloatingBanner();
}

function initFloatingBanner() {
  const floatingBanner = document.getElementById('atFloatingBanner');
  
  if (floatingBanner) {
    new ATFloatingBanner(floatingBanner);
  }
}

// Shopifyテーマエディタ対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && event.target instanceof HTMLElement) {
      const floatingBanner = event.target.querySelector('#atFloatingBanner');
      if (floatingBanner && floatingBanner instanceof HTMLElement) {
        new ATFloatingBanner(floatingBanner);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    // 必要に応じてクリーンアップ処理を追加
  });
}

